// extracted by mini-css-extract-plugin
export default {"cls1":"SourceAccountView-CurrencyWrapper_cls1__AcTSn","cls2":"SourceAccountView-CurrencyWrapper_cls2__TDHcT SourceAccountView-CurrencyWrapper_cls1__AcTSn"};